import React from 'react';
import { ClickableElement } from '@cko/primitives';
import { IconActionPasswordShow, IconActionPasswordHide } from '@cko/icons';
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
const ShowPasswordButton = ({ showPassword, onToggle }) => {
    const handleClick = (event) => {
        event.preventDefault();
        onToggle();
    };
    return (React.createElement(ClickableElement, { onClick: handleClick, "data-testid": "show-password-button" },
        React.createElement("div", { style: { marginTop: '2px' } }, showPassword ? (React.createElement(IconActionPasswordHide, { "data-testid": "icon-action-password-hide" })) : (React.createElement(IconActionPasswordShow, { "data-testid": "icon-action-password-show" })))));
};
export default ShowPasswordButton;
